<template>
  <div class="page">
    <el-divider></el-divider>
    <el-form ref="ruleForm">
      <el-form-item label="公司：" class="page-input" prop="companyCode">
        <el-select v-model="personCompanyCode" placeholder="请选择公司" @change="changeCompany">
          <el-option
            v-for="item in companyList"
            :key="item.personCompanyCode"
            :label="item.personCompanyName"
            :value="item.personCompanyCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <el-row class="page-row">
      <el-input
        placeholder="请输入内容"
        v-model="searchValue"
        filterable
        clearable
        suffix-icon="el-icon-search"
        class="inputIcon"
      ></el-input>
      <el-button
        v-for="item in menuButtonList"
        type="primary"
        :key="item.id"
        @click="click(item.attributes.buttonUrl)"
        class="fixed-bottom-btn"
        >{{ item.label }}</el-button
      >
    </el-row>
    <el-row type="flex">
      <div class="list">
        <el-scrollbar>
          <el-tree
            ref="tree"
            :data="treeData"
            node-key="id"
            show-checkbox
            draggable
            highlight-current
            auto-expand-parent
            :allow-drop="allowDrop"
            @node-drop="handleDrop"
            :props="treeProp"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            @check-change="handleCheckChange"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
            :default-expanded-keys="defaultShowNodes"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <i
                  v-if="data.type != '01'"
                  class="el-icon-edit"
                  style="padding-left: 8px"
                  @click="() => edit(node, data)"
                ></i>
                <i
                  v-if="data.isReviewed != 1 && data.type != '01'"
                  class="el-icon-remove-outline"
                  style="padding-left: 8px"
                  @click="() => remove(node, data)"
                ></i>
                <i
                  v-if="data.type == '01' ? data.isEnabled == 1 : data.leafFlag != 0"
                  class="el-icon-circle-plus-outline"
                  style="padding-left: 8px"
                  @click="() => append(data)"
                ></i>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="info-content">
        <AreaInformation
          ref="areaInformation"
          v-if="showAreaData.type == 1 && showAreaData.id != ''"
          :form.sync="form"
          :showAreaData.sync="showAreaData"
          :areaButtonList.sync="areaButtonList"
          @refreshTree="querySpaceTree"
          style="margin-bottom: 20px"
          @updateSucess="updateSucess($event)"
        ></AreaInformation>
        <AssetInformationCard
          ref="assetInformationCard"
          v-if="showAreaData.type != 1 && showAreaData.id != ''"
          :form.sync="form"
          :showAreaData.sync="showAreaData"
          style="margin-bottom: 20px"
          @updateCardInfo="updateCardInfo($event)"
        ></AssetInformationCard>
        <div v-if="showAreaData.id == ''" style="margin: 20px">暂无数据</div>
      </div>
    </el-row>
    <AddPropertyDialog
      :companyList.sync="companyList"
      :showDialog.sync="showAddPropertyDialog"
      :personCompanyCode.sync="personCompanyCode"
      :parentId.sync="parentId"
      v-if="showAddPropertyDialog"
      @closeDialog="showAddPropertyDialog = false"
      @refreshTree="querySpaceTree"
      :appendType="appendType"
    />
    <UpdatePropertyDialog
      :companyList.sync="companyList"
      :showDialog.sync="showUpdatePropertyDialog"
      :personCompanyCode.sync="personCompanyCode"
      :currentUpdateId.sync="currentUpdateId"
      v-if="showUpdatePropertyDialog"
      @closeDialog="showUpdatePropertyDialog = false"
      @refreshTree="querySpaceTree"
      :appendType="appendType"
      :params.sync="spaceCardInfo"
    >
    </UpdatePropertyDialog>
    <AddAreaDialog
      ref="addAreaDialog"
      v-if="showAddAreaDilaog"
      :showDialog.sync="showAddAreaDilaog"
      @closeDialog="showAddAreaDilaog = false"
      :addTitle="addTitle"
      :isEnabled="isEnabled"
      @submit="addArea($event)"
    >
    </AddAreaDialog>
    <DeleteSureDialog
      ref="deleteSureDialog"
      v-if="showDeleteSureDialog"
      :showDialog="showDeleteSureDialog"
      :message="deleteMessage"
      @closeDialog="showDeleteSureDialog = false"
      @sure="sureRemove"
    ></DeleteSureDialog>
  </div>
</template>
<script>
  import AreaInformation from './component/areaInformationCard.vue';
  import AssetInformationCard from './component/assetInformationCard.vue';
  import AddPropertyDialog from '../spaceAssets/component/addPropertyDialog.vue';
  import UpdatePropertyDialog from '../spaceAssets/component/updatePropertyDialog.vue';
  import AddAreaDialog from '../spaceAssets/component/addAreaDialog.vue';
  import API from '@/api/property/spaceAssets';
  import DeleteSureDialog from './component/deleteSureDialog.vue';
  import { generalFormItem } from '@/api/property/model';

  export default {
    name: 'spaceAssets',
    components: {
      AreaInformation,
      AddPropertyDialog,
      AddAreaDialog,
      AssetInformationCard,
      DeleteSureDialog,
      UpdatePropertyDialog,
    },
    computed: {
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
    },
    data() {
      return {
        treeProp: {
          disabled: (data) => {
            if (data.effectiveStatus == '03') {
              return true;
            }
          },
        },
        appendType: '', //需要添加的类型
        deleteIndex: '', //删除的序号
        deleteId: '',
        deleteChildren: null,
        ids: [], // 选中数组
        spaceCardInfo: JSON.parse(JSON.stringify(generalFormItem)),
        showDeleteSureDialog: false,
        deleteMessage: '',
        showAddPropertyDialog: false,
        showUpdatePropertyDialog: false,
        showAddAreaDilaog: false,
        treeData: [],
        page: { pages: 10, pageSize: 10, total: 100 },
        form: { test: '测试' },
        companyList: [], //公司数组
        searchValue: '',
        load: false,
        personCompanyCode: '',
        parentId: '',
        currentUpdateId: '',
        addTitle: '',
        isEnabled: 0,
        changeIdList: [],
        tempNodeData: null,
        menuButtonList: [],
        areaButtonList: [],
        showAreaData: {
          type: 1, //显示类型
          id: '', //点击的id
          children: [], //对应的子tree
        },
        defaultShowNodes: [],
        isFirst: '0', //0-从审核页面初次跳转加载，1-保存后加载数据
        auditId: '',
        toPath: '',
        fromPath: '',
      };
    },
    watch: {
      searchValue(val) {
        this.$refs.tree.filter(val);
      },
      personCompanyCode() {
        this.querySpaceTree();
      },
      $route: {
        handler(to, from) {
          this.toPath = to?.path;
          this.fromPath = from?.path;
        },
        deep: true,
      },
      isFirst: {
        handler(newV, old) {
          console.log(newV, old, 'kkkk');
        },
        deep: true,
      },
    },
    mounted() {
      this.getCompany();
      this.getButtonList();
      console.log('执行');
      console.log('mounted');
    },
    methods: {
      setInitLocation(auditId) {
        console.log('设置初始值', auditId);
        // 当前选中值
        this.$refs.tree.setCurrentKey(auditId);
        // 勾选
        this.$refs.tree.setChecked(auditId, true);
        var selected = this.$refs.tree.getCurrentNode();
        // 展开父节点
        if (this.$refs.tree.getNode(selected) && this.$refs.tree.getNode(selected)?.parent) {
          this.expandParent(this.$refs.tree.getNode(selected).parent);
        }
        // 加载右侧数据
        this.handleNodeClick(selected);
        if (this.isFirst == '0') {
          console.log(this.isFirst, '打开');
          // 打开弹窗
          this.isFirst = '1';
          this.edit(this.$refs.tree.getNode(selected), selected);
        }
      },
      expandParent(node) {
        node.expanded = true;
        if (node?.parent) {
          this.expandParent(node.parent);
        }
      },
      inintData() {
        let auditId = this.$route.query?.auditId;
        if (auditId) {
          this.setInitLocation(auditId);
        }
      },
      // 树节点展开
      handleNodeExpand(data) {
        // 保存当前展开的节点
        let flag = false;
        this.defaultShowNodes.some((item) => {
          if (item === data.id) {
            // 判断当前节点是否存在， 存在不做处理
            flag = true;
            return true;
          }
        });
        if (!flag) {
          // 不存在则存到数组里
          this.defaultShowNodes.push(data.id);
        }
      },
      // 树节点关闭
      handleNodeCollapse(data) {
        this.defaultShowNodes.some((item, i) => {
          if (item === data.id) {
            // 删除关闭节点
            this.defaultShowNodes.length = i;
          }
        });
      },
      allowDrop(draggingNode, dropNode, type) {
        if (draggingNode.data.parentId == dropNode.data.id) {
          return type == 'inner';
        } else if (draggingNode.data.parentId == dropNode.data.parentId) {
          return type != 'inner';
        } else {
          return false;
        }
      },
      handleDrop(draggingNode) {
        this.changeIdList = [];
        if (draggingNode.data.parentId == 0) {
          this.changeIdList = this.treeData.map((item) => item.id);
        } else {
          this.changeSort(draggingNode.data.parentId, this.treeData);
        }
        console.log('排序后的id', this.changeIdList);
        this.updateSort();
      },
      changeSort(id, data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id == id) {
            this.changeIdList = data[i].children.map((item) => item.id);
          } else {
            if (data[i].children.length > 0) {
              this.changeSort(id, data[i].children);
            }
          }
        }
      },
      async updateSort() {
        const { data } = await this.$axios.post(API.UPDATE_SORT, {
          type: 'space',
          ids: this.changeIdList,
        });
        if (data.code == 0) {
          console.log('排序成功');
        } else {
          this.$message.error(data.msg);
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          if (res.length > 0) {
            this.menuButtonList = res[0].children;
          }

          if (res.length > 1) {
            this.areaButtonList = res[1].children;
          }
        });
      },
      // 菜单按钮点击处理
      click(type) {
        this[type]();
      },
      //获取公司信息
      getCompany() {
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          console.log('getCompany', res);
          if (res.data.code == 0) {
            this.companyList = res.data.data.personCompanyInfo;
            this.personCompanyCode = this.userInfo.companyCode;
          }
        });
      },
      //获取tree
      querySpaceTree() {
        if (this.personCompanyCode == null || this.personCompanyCode == '') {
          return;
        }
        console.log('querySpaceTree', this.personCompanyCode);
        this.$axios.get(API.SPACE, { companyNo: this.personCompanyCode }).then((res) => {
          console.log('querySpaceTree', res);
          if (res.data.code == '0') {
            this.changeListToTree(res.data.data);
            if (this.treeData.length > 0 && this.showAreaData.id == '') {
              this.showAreaData.type = this.treeData[0].type;
              this.showAreaData.id = this.treeData[0].id;
              this.showAreaData.leafFlag = this.treeData[0].leafFlag;
              this.showAreaData.leaseStatus = this.treeData[0].leaseStatus;
              this.showAreaData.children = this.treeData[0].children;
            }
            if (this.treeData.length == 0) {
              this.showAreaData.id = '';
            }
            if (this.$refs.assetInformationCard != null) {
              this.$refs.assetInformationCard.getSpaceDetail();
            }
          }
        });
      },
      //将集合转为树形结构
      changeListToTree(value) {
        this.treeData = [];
        this.tree_init(value, this.treeData);
      },
      tree_init(data, arr) {
        data.forEach((ele) => {
          if (!ele.parentId) {
            arr.push({
              id: ele.id,
              label: ele.name,
              type: ele.type,
              leaseStatus: ele.leaseStatus,
              effectiveStatus: ele.effectiveStatus,
              auditStatus: ele.auditStatus,
              parentStr: ele.parentStr,
              parentId: ele.parentId,
              area: ele.area,
              isReviewed: ele.isReviewed,
              leafFlag: ele.leafFlag,
              isEnabled: ele.isEnabled,
              children: [],
            });
          } else {
            this.tree(ele, arr);
          }
        });
        this.$nextTick(() => {
          this.inintData();
        });
        console.log('changeListToTree', arr);
      },
      tree(data, arr) {
        arr.forEach((ele) => {
          if (parseInt(ele.id) === data.parentId) {
            ele.children.push({
              id: data.id,
              label: data.name,
              type: data.type,
              leaseStatus: data.leaseStatus,
              effectiveStatus: data.effectiveStatus,
              auditStatus: data.auditStatus,
              parentStr: data.parentStr,
              parentId: data.parentId,
              area: data.area,
              isReviewed: data.isReviewed,
              leafFlag: data.leafFlag,
              isEnabled: data.isEnabled,
              children: [],
            });
          } else {
            this.tree(data, ele.children);
          }
        });
      },
      changeCompany(value) {
        this.personCompanyCode = value;
        console.log('changeCompany', value);
      },
      addAreaDilaog() {
        this.addTitle = '';
        this.isEnabled = 0;
        this.showAddAreaDilaog = true;
      },
      append(data) {
        console.log(data);
        this.showAddPropertyDialog = true;
        this.parentId = data.id;
        let arr = { '01': '02', '02': '03', '03': '04', '04': '05', '05': '06' };
        this.appendType = arr[data.type];
      },
      edit(node, data) {
        if (data.children.length > 0) {
          return this.$message.error(this.getNotDeletMessage(data, '编辑'));
        }
        // 只有空间才做以下判断
        if (data.leafFlag == 0) {
          if (data.leaseStatus == '02') {
            // return this.$message.warning('该空间已出租,不允许修改！');
          } else if (data.auditStatus == '02') {
            return this.$message.warning('该空间待审核,不允许修改！');
          } else if (data.effectiveStatus == '03') {
            return this.$message.warning('该空间已失效,不允许修改！');
          }
        }

        console.log('edit', data, node);
        if (data.type == '01') {
          this.addTitle = data.label;
          this.isEnabled = data.isEnabled;
          this.showAddAreaDilaog = true;
          this.tempNodeData = data;
        } else {
          this.showUpdatePropertyDialog = true;
          this.currentUpdateId = data.id;
          this.appendType = data.type;
        }
      },
      updateCardInfo(value) {
        if (value.space.assetType != null) {
          value.space.tempAssetType = value.space.assetType.split(',');
        }
        value.space.selfUseFlag = value.space.selfUseFlag.toString();
        value.space.selfOwnedFlag = value.space.selfOwnedFlag.toString();
        value.space.leafFlag = value.space.leafFlag.toString();
        this.spaceCardInfo.spaceDTO = value.space;
        this.spaceCardInfo.energyDTOList = value.spaceEnergyList;
      },
      remove(node, data) {
        if (data.children.length > 0) {
          this.$message.error(this.getNotDeletMessage(data));
        } else {
          console.log('remove', data);
          if (data.leafFlag == 0) {
            if (data.leaseStatus == '02') {
              this.$message.warning('该空间已出租,不允许删除！');
              return;
            } else if (data.effectiveStatus == '02') {
              return this.$message.warning('该空间已生效,不允许删除！');
            } else if (data.effectiveStatus == '03') {
              return this.$message.warning('该空间已失效,不允许删除！');
            } else if (data.auditStatus == '02') {
              return this.$message.warning('该空间待审核,不允许删除！');
            }
          }

          this.deleteMessage = this.getDeletMessage(data);
          const parent = node.parent;
          this.deleteChildren = parent.data.children || parent.data;
          this.deleteIndex = this.deleteChildren.findIndex((d) => d.id === data.id);
          this.deleteId = data.id;
          this.showDeleteSureDialog = true;
        }
      },
      getNotDeletMessage(data, str = '删除') {
        let arr = {
          '01': `片区下有子层级，不允许${str}！`,
          '02': `资产下有子层级，不允许${str}！`,
          '03': `单元（楼栋）下有子层级，不允许${str}！`,
          '04': `楼层下有子层级，不允许${str}！`,
        };
        return arr[data.type];
      },
      getDeletMessage(data) {
        console.log(data);
        return '您确定要删除该空间吗？';
      },
      sureRemove() {
        this.$axios
          .post(API.SPACE_DELETE + '?id=' + this.deleteId, {
            id: this.deleteId,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message.success('操作成功');
              this.deleteChildren.splice(this.deleteIndex, 1);
              this.$refs.deleteSureDialog.closeDialog();
              if (this.deleteId == this.showAreaData.id) {
                this.showAreaData.id = '';
                this.showAreaData.type = this.treeData[0].type;
                this.showAreaData.id = this.treeData[0].id;
                this.showAreaData.leafFlag = this.treeData[0].leafFlag;
                this.showAreaData.leaseStatus = this.treeData[0].leaseStatus;
                this.showAreaData.children = this.treeData[0].children;
              }
            } else {
              this.$refs.deleteSureDialog.loading = false;
              if (res.data.msg != '') {
                return this.$message.error(res.data.msg);
              }
              this.$message.error('删除失败，请重试');
            }
          });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //提交审核
      submitReview() {
        let list = this.$refs.tree.getCheckedKeys();
        if (list.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择数据！',
          });
          return;
        }
        let arr = [];
        for (let i = 0; i < list.length; i++) {
          let node = this.$refs.tree.getNode(list[i]);
          console.log('node', node.get);
          this.getChecked(node.data, arr);
        }
        console.log('arr', arr);
        this.$axios.post(API.SPACE_BATCH_SUBMIT + '?ids=' + arr).then((res) => {
          if (res.data.code == '0') {
            this.$message({
              type: 'success',
              message: '提交成功',
            });
            this.querySpaceTree();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
            });
          }
        });
      },
      getChecked(data, arr) {
        arr.push(data.id);
        if (data.children != null && data.children.length > 0) {
          for (let i = 0; i < data.children.length; i++) {
            this.getChecked(data.children[i], arr);
          }
        }
      },
      changeSpace() {
        let list = this.$refs.tree.getCheckedNodes();
        let canChangeSpace = false;
        let district = '';
        let assets = '';
        let unit = '';
        let floor = '';
        let room = '';
        let area = '';
        let spaceName = '';
        let spaceId = '';
        if (list.length > 0) {
          if (list.length == 1) {
            let type = list[0].type;
            if (list[0].leafFlag == '0') {
              if (list[0].effectiveStatus == '02' && list[0].leaseStatus == '01') {
                let ids = list[0].parentStr.split('/');
                area = list[0].area;
                spaceName = list[0].label;
                spaceId = list[0].id;
                if (type == '02') {
                  assets = ids[1];
                  district = ids[0];
                } else if (type == '03') {
                  unit = ids[2];
                  assets = ids[1];
                  district = ids[0];
                } else if (type == '04') {
                  floor = ids[3];
                  unit = ids[2];
                  assets = ids[1];
                  district = ids[0];
                } else {
                  room = ids[4];
                  floor = ids[3];
                  unit = ids[2];
                  assets = ids[1];
                  district = ids[0];
                }
                canChangeSpace = true;
              } else {
                return this.$message.warning(
                  '该资产不能进行变更，请选择“已生效”且“待出租”的资产！'
                );
              }
            } else {
              return this.$message.warning('该资产不能进行变更，请重新选择！');
            }
          } else {
            return this.$message.warning('只能选择单个空间进行变更，请重新选择！');
          }
        }

        // this.$store.dispatch('tagsView/delView', {
        //   path: '/property/spaceAssets',
        //   name: 'spaceAssets',
        //   meta: {
        //     keepAlive: true,
        //     title: '',
        //   },
        //   query: { personCompanyCode: this.personCompanyCode },
        // });
        this.$router.push({
          path: '/property/changeSpace',
          query: {
            personCompanyCode: this.personCompanyCode,
            canChangeSpace: canChangeSpace,
            spaceName: spaceName,
            spaceId: spaceId,
            district: district,
            assets: assets,
            unit: unit,
            floor: floor,
            room: room,
            area: area,
          },
        });
      },
      handleNodeClick(data) {
        console.log(data);
        this.showAreaData.type = data.type;
        this.showAreaData.id = data.id;
        this.showAreaData.leafFlag = this.treeData[0].leafFlag;
        this.showAreaData.children = data.children;
      },
      updateSucess(data) {
        if (data.type == '0') {
          this.tempNodeData.label = data.data;
          this.$refs.addAreaDialog.closeDialog();
        } else {
          this.$refs.addAreaDialog.endLoading();
        }
      },
      addArea(data) {
        if (this.addTitle != '') {
          this.$refs.areaInformation.update(data);
          return;
        }
        console.log('addArea', data);
        let params = JSON.parse(JSON.stringify(generalFormItem));
        var list = this.companyList.filter(
          (item) => item.personCompanyCode == this.personCompanyCode
        );
        params.energyDTOList = null;
        params.spaceDTO.spaceCompanyNo = list[0].personCompanyCode;
        params.spaceDTO.spaceCompanyName = list[0].personCompanyName;
        params.spaceDTO.name = data;
        params.spaceDTO.type = '01';
        params.spaceDTO.leafFlag = '1';

        this.$axios.post(API.SAVE, params).then((res) => {
          if (res.data.code == '0') {
            this.querySpaceTree();
            this.$message.success('保存成功');
            this.$refs.addAreaDialog.closeDialog();
          } else {
            this.$refs.addAreaDialog.endLoading();
            this.$message({
              type: 'error',
              message: res.data.msg,
            });
          }
        });
      },
      handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
        // if (data.children != null) {
        //   this.setChecked(data.children, checked);
        // }
      },
      setChecked(data, checked) {
        for (let i = 0; i < data.length; i++) {
          this.$refs.tree.setChecked(data[i].id, checked, false);
          if (data[i].children != null) {
            this.setChecked(data[i].children, checked);
          }
        }
      },
    },
    activated() {
      if (this.fromPath == '/property/spaceAuditDetail' && this.toPath == '/property/spaceAssets') {
        this.isFirst = '0';
        this.inintData(this.$route.query?.auditId);
      }
    },
  };
</script>
<style scoped lang="scss">
  .page {
    background-color: white;
    margin-top: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    height: 100%;
    top: 0;

    .page-input {
      padding-top: 15px;
      padding-left: 20px;
      padding-bottom: 15px;
    }

    .el-tree {
      display: inline-block;
    }

    ::v-deep .el-tree__empty-block {
      width: 300px;
    }

    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin: 1px 0;
    }

    .page-row {
      margin-top: 15px;
      padding-top: 15px;
      padding-bottom: 15px;
      background-color: #f6f7f9;
    }

    .inputIcon {
      padding-left: 10px;
      width: 300px;
    }

    .el-input__icon {
      height: 100%;
      width: 25px;
      text-align: right;
      transition: all 0.3s;
      line-height: 40px;
    }

    .fixed-bottom-btn {
      border-radius: 2px;
      height: 32px;
      min-width: 80px;
      font-size: 12px;
      margin-left: 10px;
    }

    .list {
      max-width: 300px;
      min-width: 300px;
      max-height: 520px;
      overflow: auto;
    }
    // .info-content{
    //   max-height: 520px;
    //   overflow-y: auto;
    // }

    .custom-tree-node {
      font-size: 14px;
      padding-right: 8px;
    }

    ::v-deep .el-tree {
      background-color: #f6f7f9;
      height: 100%;
    }

    .el-pagination {
      margin-top: 20px;
    }
  }

  ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #66b1ff;
    color: white;
  }
</style>
